<template>
  <div>
    <page-title icon="fas fa-chart-pie" main="Avaliação Pessoal"> </page-title>

    <div class="card mt-2" style="padding: 0rem 1rem">
      <div class="row">
        <div  class="col-lg-12 card-header">
              <h5 class="h3 mb-0">Avaliação Pessoal</h5>
              <h6 class="text-uppercase text-muted ls-1 mb-1">  Configure quais dados deverão ser listados:  </h6>
            </div>
        <div class="col-md-3 mt-3 mb-3">
          <label class="form-control-label">Cargo</label>
          <multiselect
            v-model="filterRole"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            :options="roles"
            label="name"
            placeholder="Selecionar Cargo"
            track-by="id"
            @input="getUsers"
          />
        </div>

        <div class="col-md-3 mt-3 mb-3">
          <label class="form-control-label">Usuarios</label>
          <multiselect
              v-model="filterUser"
              :options="users"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              placeholder="Selecionar Usuario"
              label="name"
              track-by="id"
              :allow-empty="true"
            ></multiselect>
        </div>

        <div class="col-md-3 mt-3 mb-3">
          <label class="form-control-label">Data</label>
          <multiselect
            v-model="anoParticipation"
            :options="participation"
            :select-label="''"
            :deselect-label="''"
            :selected-label="'Selecionado'"
            placeholder="Selecionar Data"
            label="descricao"
            track-by="id"
          />
        </div>

        <div class="col-md-3 mt-5 ">
          <base-button icon type="info" @click="clickedEvaluate">
            <span class="btn-inner--icon">
              <i class="fas fa-search"></i>
            </span>
            <span class="btn-inner--text"><strong>Avaliar</strong></span>
          </base-button>
           <base-button
            type="secondary"
            class="mr-2"
            @click="clearFilters">
            Limpar Filtros
          </base-button>
        </div>
      </div>
    </div>

    <card v-if="hide">
      <h3>METAS QUANTITATIVAS</h3>
      <br />
      <el-table
        v-loading = "isLoading"
        class="table-responsive table-flush"
        header-row-class-name="thead-light"
        :data="descriptionQuantitatives"
        stripe="stripe"
        border
        style="width: 100%"
      >
        <el-table-column label="Metas" prop="description" max-width="30px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.description"
              @change="handleEditRow(scope.row)"
              :disabled="true"
              style="color: gray"

            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Peso" prop="weight" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.weight"
              @change="handleEditRow(scope.row)"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Nota" prop="grade" min-width="15px" sortable>
          <template slot-scope="scope">
            <div v-if="outOfDate">
              <el-tooltip content="Fora de período de avaliações" placement="top">
                <el-input
                  v-model="scope.row.grade"
                  @change="handleEditRow(scope.row)"
                  :disabled="outOfDate"
                >
                </el-input>
              </el-tooltip>
            </div>
            <div v-else slot-scope="scope">
              <el-input
                v-model="scope.row.grade"
                @change="handleEditRow(scope.row)"
              >
              </el-input>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Pontos" prop="points" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.points"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Total" prop="total" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.total"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
    </card>

    <card v-if="hide">
      <h3>METAS PESSOAIS</h3>
      <br />
      <el-table
        v-loading = "isLoading"
        class="table-responsive table-flush"
        header-row-class-name="thead-light"
        :data="descriptionsPessoal"
        stripe="stripe"
        border
        style="width: 100%"
      >
        <el-table-column label="Metas" prop="description" max-width="30px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.description"
              @change="handleEditRow(scope.row)"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Peso" prop="weight" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.weight"
              @change="handleEditRow(scope.row)"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Nota" prop="grade" min-width="15px" sortable>
          <template slot-scope="scope">
            <div v-if="outOfDate">
              <el-tooltip content="Fora de período de avaliações" placement="top">
                <el-input
                  v-model="scope.row.grade"
                  @change="handleEditRow(scope.row)"
                  :disabled="outOfDate"
                >
                </el-input>
              </el-tooltip>
            </div>
            <div v-else slot-scope="scope">
              <el-input
                v-model="scope.row.grade"
                @change="handleEditRow(scope.row)"
              >
              </el-input>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Pontos" min-width="15px" sortable>
          <template >
            <el-input
              :value="0"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Total" min-width="15px" sortable>
          <template >
            <el-input
              :value="0"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
    </card>

    <card v-if="hide">
      <h3>METAS QUALITATIVAS</h3>
      <br />
      <el-table
        v-loading = "isLoading"
        class="table-responsive table-flush"
        header-row-class-name="thead-light"
        :data="descriptionQualitatives"
        stripe="stripe"
        border
        style="width: 100%"
      >
        <el-table-column label="Metas" prop="description" max-width="30px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.description"
              @change="handleEditRow(scope.row)"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Peso" prop="weight" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.weight"
              @change="handleEditRow(scope.row)"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Nota" prop="grade" min-width="15px" sortable>
          <template slot-scope="scope">
            <div v-if="outOfDate">
              <el-tooltip content="Fora de período de avaliações" placement="top">
                <el-input
                  v-model="scope.row.grade"
                  @change="handleEditRow(scope.row)"
                  :disabled="outOfDate"
                >
                </el-input>
              </el-tooltip>
            </div>
            <div v-else slot-scope="scope">
              <el-input
                v-model="scope.row.grade"
                @change="handleEditRow(scope.row)"
              >
              </el-input>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Pontos" prop="points" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.points"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column label="Total" prop="total" min-width="15px" sortable>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.total"
              :disabled="true"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
    </card>

    <!-- <base-button v-if="!editMode" @click="save" type="info">
      <span class="btn-inner--text"><strong>Salvar</strong></span>
    </base-button> -->

    <card v-if="hide">
        <div style="margin-top: 50px">
          <div  class="col-lg-12 card-header">
            <h3>COMENTARIOS DO AVALIADOR:</h3>
          </div>
          <div class="col-lg-12" v-if="comment && comment.description">
            <base-input>
                <textarea
                  class="form-control"
                  rows="5"
                  :value="comment.description"
                  @input="upComment($event.target.value)"
                  ref="input"
                  placeholder="Comentário"
                ></textarea>
                <div class="container">
                  <div class="row">
                    <base-button @click="saveComment(); save()" class="ml-auto" icon type="info">
                      <span class="btn-inner--icon"> <i class="fas fa-search"></i> </span>
                      <span class="btn-inner--text"><strong>Salvar</strong></span>
                    </base-button>
                  </div>
                </div>
            </base-input>
          </div>
          <div class="col-lg-12" v-else>
            <base-input>
                <textarea
                  class="form-control"
                  rows="5"
                  placeholder="Não há comentários relacionados a esse usuário"
                  @input="upComment($event.target.value)"
                ></textarea>
                <div class="container" >
                  <div class="row">

                    <base-button @click="saveComment(); save()" class="ml-auto mt-2" icon type="info">
                      <span class="btn-inner--text"><strong>Salvar</strong></span>
                    </base-button>
                  </div>
              </div>
            </base-input>
          </div>
      </div>
    </card>
  </div>
</template>

<script>
import Vue from "vue";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import moment from 'moment'

import Modal from "@/components/Modal";
import { DatePicker } from "element-ui";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  name: "app",
  components: {
    PageTitle,
    Multiselect,
    Modal,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      avaliations: [],
      addCount:0,
      hide: false,
      roles: [],
      users: [],
      isLoading: false,
      filterUser: "",
      filterRole: "",
      filteredUsers: [],
      participation: [],
      anoParticipation: "",
      teste_1: false,
      descriptionQuantitatives: [],
      descriptionsPessoal: [],
      descriptionQualitatives: [],
      resultGoals: [],
      comment: {description: ''},
      outOfDate: false,
      editMode: true,
      comment_id: "",
    };
  },
  mounted() {
    this.getParticipation();
    this.initValues();
    this.getRoles();
    this.checkDates()
  },
  methods: {
    async clickedEvaluate() {
      this.avaliations = []
      this.descriptionQuantitatives = []
      this.descriptionsPessoal = []
      this.descriptionQualitatives = []
      // this.comment = ''
      if (!this.filterRole) {
        this.$toasted.global.defaultError({ msg: 'Insira um usuário !' })
        return
      }
      if (!this.anoParticipation) {
        this.$toasted.global.defaultError({ msg: 'Insira um ano PPR !' });
        return
      }
      this.hide = true;
      this.getAvaliation();

    },
    getRoles() {
      this.$http.secured.get("/api/v1/roles")
        .then((response) => {
          console.log(response)
          this.roles = response.data.roles
          console.log(this.roles)
        });
    },
    getUsers(role){
      console.log(role)
      this.$http.secured.get("/api/v1/users", { params: { status: true, q: { role_id: role.id } } })
        .then((response) => {
          this.users = response.data.users
          console.log("users",this.users)
        })
    },
    async checkDates() {
      const response = await this.$http.secured.get("/api/v1/admin/settings")
      try {
        let finalDateAvaliation = moment(response.data.avaliation_review.end_date.value).format('L')
        this.outOfDate = new Date() > new Date(finalDateAvaliation) ? true : false
      }
      catch(error) { console.log(error) }
    },
    setDescriptions() {
      var dataAvaliation = {
        q: {
          participation_ppr_id: this.anoParticipation.id,
          role_id: this.filterRole.id,
          is_file: true
        },
      };
      this.$http.secured.get("/api/v1/avaliation_withs", { params: dataAvaliation })
        .then((response) => {
          this.avaliations = response.data
          console.log(response.data)
          this.descriptionQuantitatives = this.avaliations.filter(avaliation => avaliation.kind == "METAS QUANTITATIVAS")
          this.descriptionsPessoal      = this.avaliations.filter(avaliation => avaliation.kind == "METAS PESSOAIS")
          this.descriptionQualitatives  = this.avaliations.filter(avaliation => avaliation.kind == "METAS QUALITATIVAS")
        })
    },
    clickedReview(){
      this.teste_1 = true;
    },
    initValues(){
      if(this.$route.params.role_id) this.filterRole.id = this.$route.params.role_id
      if(this.$route.params.participation_ppr_id) this.anoParticipation.id = this.$route.params.participation_ppr_id
    },
    getParticipation() {
      this.$http.secured
        .get(`/api/v1/admin/participation_pprs`, { params: { unpaged: true } })
        .then((response) => {
          console.log("da",response)
          this.participation = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    handleEditRow(avaliation_resume) {
      if(this.editMode)
        this.$http.secured
          .put(`/api/v1/avaliation_withs/${avaliation_resume.id}`, avaliation_resume )
          .then(response => {
            this.$toasted.global.defaultSuccess();
            this.getAvaliation()
          })
          .catch(error => console.log(error));
    },
    removeQuantitative(quantitative) {
      this.$http.secured
        .delete(`/api/v1/avaliation_withs/${quantitative.id}`, quantitative)
        .then((response) => {
          console.log("response: ", response.data);
          this.getAvaliation();
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => {
          this.setError(error, "Cannot remove quantitative");
          this.$refs.observer.setErrors(this.errors);
        });
    },
    addQuantitative(quantitative) {
      let newRow  = {
        weight: 0,
        description:'Nova',
        kind: 'METAS QUANTITATIVAS',
        grade: 0,
        total: 0,
        points: 0,
        participation_ppr_id: this.anoParticipation.id,
        role_id: this.filterRole.id,
      };
      this.$http.secured
        .post(`/api/v1/avaliation_withs`, newRow)
        .then((response) => {
          console.log("response: ", response.data);
          this.getAvaliation();
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => {
          this.setError(error, "Cannot remove quantitative");
          this.$refs.observer.setErrors(this.errors);
          // this.$toasted.global.defaultError();
        });
    },
    removePersonal(personal) {
      this.$http.secured
        .delete(`/api/v1/avaliation_withs/${personal.id}`, personal)
        .then((response) => {
          console.log("response: ", response.data);
          this.getAvaliation();
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => {
          this.setError(error, "Cannot remove personal");
          // this.$toasted.global.defaultError();
          this.$refs.observer.setErrors(this.errors);
        });
    },
    addPersonal(personal) {
      let newRow  = {
        kind: "METAS PESSOAIS",
        description:"Nova",
        weight: 0,
        grade: 0,
        points: 0*10,
        total: 0* 0,
        role_id: this.filterRole.id,
        participation_ppr_id: this.anoParticipation.id
      };
      this.$http.secured
        .post(`/api/v1/avaliation_withs`, newRow)
        .then((response) => {
          console.log("response: ", response.data);
          this.getAvaliation();
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => {
          this.setError(error, "Cannot remove personal");
          this.$refs.observer.setErrors(this.errors);
          // this.$toasted.global.defaultError();
        });
    },
    removeQualitative(qualitative) {
      this.$http.secured
        .delete(`/api/v1/avaliation_withs/${qualitative.id}`, qualitative)
        .then((response) => {
          console.log("response: ", response.data);
          this.getAvaliation();
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => {
          this.setError(error, "Cannot remove qualitative");
          // this.$toasted.global.defaultError();
          this.$refs.observer.setErrors(this.errors);
        });
    },
    addQualitative(qualitative) {
      let newRow  = {
        kind: "METAS QUALITATIVAS",
        description: "Nova",
        weight:0,
        grade:0,
        points:0*10,
        total:0,
        role_id: this.filterRole.id,
        participation_ppr_id: this.anoParticipation.id
      };
      this.$http.secured
        .post(`/api/v1/avaliation_withs`, newRow)
        .then((response) => {
          console.log("response: ", response.data);
          this.getAvaliation();
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => {
          this.setError(error, "Cannot remove qualitative");
          this.$refs.observer.setErrors(this.errors);
          // this.$toasted.global.defaultError();
        });
    },
    async getAvaliation() {
      this.isLoading = true;
      var dataAvaliation = {
        q: {
          participation_ppr_id: this.anoParticipation.id,
          role_id: this.filterRole.id,
          user_id: this.filterUser.id,
          is_file: false,
        },
      };
      const response = await this.$http.secured.get(`/api/v1/avaliation_withs`, { params: dataAvaliation })
        try {
          this.avaliations = response.data
          console.log(this.avaliations.length)
          if (this.avaliations.length > 0) {
            this.descriptionQuantitatives = this.avaliations.filter(avaliation => avaliation.kind == "METAS QUANTITATIVAS")
            this.descriptionsPessoal      = this.avaliations.filter(avaliation => avaliation.kind == "METAS QUALITATIVAS")
            this.descriptionQualitatives  = this.avaliations.filter(avaliation => avaliation.kind == "METAS PESSOAIS")
            this.getAvaliationComment();
          }
          else {
            this.editMode = false
            this.setDescriptions();
          }
        }
        catch(error) { console.log(error) };
        this.isLoading = false;
    },
    getAvaliationComment() {
      this.isLoading = true;
      var dataAvaliation = {
        q: {
          participation_ppr_id: this.anoParticipation.id,
          user_id: this.filterUser.id,
          kind: 'AVALIAÇÃO COM',
        },
      };
      console.log(dataAvaliation)
      this.$http.secured.get(`/api/v1/avaliation_comments`, { params: dataAvaliation })
        .then((response) => {
          console.log(response)
          this.comment = response.data[0] || {}
          this.isLoading = false;
        })
    },
    upComment(comment) {
      this.comment.description = comment
    },
    updateComment() {
      this.$http.secured
        .put(`/api/v1/avaliation_comments/${this.comment.id}`, { avaliation_comment: this.comment } )
        .then(response => this.$toasted.global.defaultSuccess())
        .catch(error => console.log(error));
    },
    createComment() {
      let data = {
        description: this.comment.description,
        participation_ppr_id: this.anoParticipation.id,
        user_id: this.filterUser.id,
        kind: "Avaliação COM"
      }
      this.$http.secured
        .post(`/api/v1/avaliation_comments/`, { avaliation_comment: data } )
        .then(response => this.$toasted.global.defaultSuccess())
        .catch(error => console.log(error));
    },
    saveComment() {
      if (this.comment && this.comment.id) {
        this.updateComment();
      } else {
        this.createComment();
      }
    },
    save() {
      if (this.descriptionQuantitatives.some(obj => obj.user_id == undefined))
        this.descriptionQuantitatives.map(descriptionQuantitatives => {
          descriptionQuantitatives.user_id = this.filterUser.id;
          descriptionQuantitatives.is_file = false;
          this.$http.secured.post(`/api/v1/avaliation_withs/`, descriptionQuantitatives )
            .then(response => console.log(response.data))
            .catch(error => console.log(error));
        })
      if (this.descriptionsPessoal.some(obj => obj.user_id == undefined))
        this.descriptionsPessoal.map(descriptionsPessoal => {
          descriptionsPessoal.user_id = this.filterUser.id;
          descriptionsPessoal.is_file = false;
          this.$http.secured.post(`/api/v1/avaliation_withs/`, descriptionsPessoal )
            .then(response => console.log(response.data))
            .catch(error => console.log(error));
        })
      if (this.descriptionQualitatives.some(obj => obj.user_id == undefined))
        this.descriptionQualitatives.map(descriptionQualitatives => {
          descriptionQualitatives.user_id = this.filterUser.id;
          descriptionQualitatives.is_file = false;
          this.$http.secured.post(`/api/v1/avaliation_withs/`, descriptionQualitatives )
            .then(response => {
              console.log(response.data)
            })
            .catch(error => console.log(error));
        })
    },
    clearFilters() {
      this.filterRole = "",
      this.filterUser = "",
      this.anoParticipation = ""
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  },
  watch: {},
};
</script>

<style scope src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
